// extracted by mini-css-extract-plugin
export default {"buttons":"AppSettings_buttons__SUwbc"};